<template>
    <div>
        <div :class="'nobr card card-inverse differency-card card-' + color">

            <div class="card-header nobr" style="word-wrap: normal; white-space: nowrap;">


                        <div class="pull-left" style="word-wrap: normal; white-space: nowrap;"><i :class="'pull-left fa fa-' + icon"></i> {{ title }}</div>
                <div class="pull-right" style="word-wrap: normal; white-space: nowrap;"><small>{{ average }}$</small></div>


        </div>


            <div class="card-block nobr" style="padding: 0;">
                <table class="table table-bordered debit-table table-striped table-sm table-responsive table-hover nobr">
                    <thead class="thead-default" style="word-wrap: normal; white-space: nowrap;">
                    <tr style="word-wrap: normal; white-space: nowrap;">
                        <th @click="sortData('countryId', function(e) {
                          const country = $t(`country.${e}`)
                          return country[0]
                        })" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i class="fa fa-map-o" aria-hidden="true"></i>
                            {{ $t('statistic.country') }}
                        </th>
                        <th @click="sortData('balance')" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i class="fa fa-money"
                                                                                                                              aria-hidden="true"></i>
                            {{ $t('statistic.debt') }}
                        </th>
                        <th @click="sortData('balance')" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i class="fa fa-money"
                                                                                                                              aria-hidden="true"></i>
                            {{ $t('statistic.delay_debt') }}
                        </th>
                        <th @click="sortData('todaySum')" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i class="fa fa-money"
                                                                                                                               aria-hidden="true"></i>
                            {{ $t('statistic.to_pay_for_today') }}
                        </th>
                        <th @click="sortData('weekSum')" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i class="fa fa-money"
                                                                                                                              aria-hidden="true"></i>
                            {{ $t('statistic.payout_for_the_week') }}
                        </th>
                        <th @click="sortData('lastPaymentSum')" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i
                                class="fa fa-money" aria-hidden="true"></i> {{ $t('statistic.last_payout') }}
                        </th>
                        <th @click="sortData('lastPaymentDate', function(e) {
                            return e
                        })" class="th-action" style="word-wrap: normal; white-space: nowrap;"><i class="fa fa-calendar" aria-hidden="true"></i>
                            {{ $t('statistic.date') }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="country in preparedData"
                        style="height: 8px; line-height: 8px; text-align:center; word-wrap: normal; white-space: nowrap;">
                        <th style="word-wrap: normal; white-space: nowrap;"><i class="flag" :class="'flag-' + country.code"></i>
                            <span style="vertical-align: 100%;">{{ $t('country.' + country.countryId) }}</span>
                        </th>

                        <td :style="`padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(129, 208, 234) ${country.balance / totalBalance * 100}%, transparent 0%);`">

                            <!--<span class="badge badge-pill badge-default" style="float:right; font-size: 9px; margin-top: -11px;">{{ country.average }} &#36;</span>-->

                            <table class="table table-sm table-cell" style="width:100%; margin: 0px; padding: 0px; border: 0px;" cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td style="width:45%; vertical-align:middle; word-wrap: normal; white-space: nowrap;">{{ country.balance }} &#36;</td>
                                </tr>
                            </table>
                        </td>
<!--                        Новая колонка-->
                        <td :style="`padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(129, 208, 234) ${country.balance / totalBalance * 100}%, transparent 0%);`">

                            <table class="table table-sm table-cell" style="width:100%; margin: 0px; padding: 0px; border: 0px;" cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td style="width:45%; vertical-align:middle; word-wrap: normal; white-space: nowrap;">{{ country.delay_debt }} &#36;</td>
                                </tr>
                            </table>
                        </td>
 <!--                        Новая колонка-->
                        <td :style="`padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(186, 192, 242) ${country.todaySum / totalTodaySum * 100}%, transparent 0%);`">
                            <table class="table table-sm table-cell" style="width:100%; margin: 0px; padding: 0px; border: 0px; word-wrap: normal; white-space: nowrap;" cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td style="width:45%; vertical-align:middle;">{{ country.todaySum }} &#36;</td>
                                </tr>
                            </table>
                        </td>

                        <td :style="`padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap; background: linear-gradient(to right, rgb(196, 182, 234) ${country.weekSum / totalWeekSum * 100}%, transparent 0%);`">
                            <table class="table table-sm table-cell" style="width:100%; margin: 0px; padding: 0px; border: 0px; word-wrap: normal; white-space: nowrap;" cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td style="width:45%; vertical-align:middle;">{{ country.weekSum }} &#36;</td>
                                </tr>
                            </table>
                        </td>

                        <td style="padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap;">
                            <table class="table table-sm table-cell" style="width:100%; margin: 0px; padding: 0px; border: 0px; word-wrap: normal; white-space: nowrap;" cellspacing="0"
                                   cellpadding="0">
                                <tr>
                                    <td style="width:45%; vertical-align:middle; word-wrap: normal; white-space: nowrap;">{{ country.lastPaymentSum }} &#36;</td>
                                </tr>
                            </table>
                        </td>

                        <td style="padding-top: 13px; text-align:center; word-wrap: normal; white-space: nowrap;">
                            {{ country.lastPaymentDate | moment("D MMM YYYY") }}
                        </td>
                    </tr>

                    </tbody>

                    <tfoot class="thead-default">
                    <tr>
                        <td><strong>{{ $t('statistic.in_total') }}</strong></td>
                        <td style="text-align:center;"><strong>{{ totalBalance }} <span style="color:darkolivegreen;">&#36;</span></strong></td>
                        <td style="text-align:center;"><strong>{{ totalDelayDebt }} <span style="color:darkolivegreen;">&#36;</span></strong></td>
                        <td style="text-align:center;"><strong>{{ totalTodaySum }} <span style="color:darkolivegreen;">&#36;</span></strong></td>
                        <td style="text-align:center;"><strong>{{ totalWeekSum }} <span style="color:darkolivegreen;">&#36;</span></strong></td>
                        <td style="text-align:center;"><strong>{{ totalLastPaymentSum }} <span style="color:darkolivegreen;">&#36;</span></strong>
                        </td>
                        <td style="text-align:center;"></td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
  import { map, orderBy, find, cloneDeep } from 'lodash'
  import Storage from '../api/Storage'
  // import Helper from '../api/Helper'
  // import CountryColor from '../assets/CountryColor'
  // import Helper from './../../api/Helper'

  export default {
    props: {
      color: {
        type: String,
        default: 'info',
        required: false
      },
      icon: {
        type: String,
        default: 'line-chart',
        required: false
      },
      title: {
        type: String,
        required: true
      },
      tableData: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        preparedData: null,
        average: 0,
        Storage: Storage,
        find: find,
        max: 0,
        totalBalance: 0.0,
        totalDelayDebt: 0.0,
        totalTodaySum: 0.0,
        totalWeekSum: 0.0,
        totalLastPaymentSum: 0.0,
        sortingField: 'balance',
        sortingType: 'desc'
      }
    },
    mounted () {
      this.$nextTick(function () {
        this.preparedData = this.calculateData()
      })
    },
    methods: {
      sortData (field, cb) {
        this.sortingField = field
        if (this.sortingType === 'asc') {
          this.sortingType = 'desc'
        } else {
          this.sortingType = 'asc'
        }
        this.preparedData = this.calculateData(cb)
      },
      calculateData (sortingCb) {
        let data = cloneDeep(this.tableData)
        let count = 0
        let statistic = []
        let total = 0.00
        let totalDelay = 0.00
        let totalWeekSum = 0.00
        let totalTodaySum = 0.00
        let totalLastPaymentSum = 0.00

        map(data, (d) => {
          total += parseFloat(d.balance)
          totalDelay += parseFloat(d.delay_debt)
          totalTodaySum += parseFloat(d.today_sum)
          totalWeekSum += parseFloat(d.week_sum)
          totalLastPaymentSum += parseFloat(d.last_payment_sum)
        })

        map(data, (d) => {
          const country = find(Storage.countries, {id: parseInt(d.country_id, 10)})
          statistic.push({
            countryId: d.country_id,
            balance: parseFloat(d.balance).toFixed(2),
            delay_debt: parseFloat(d.delay_debt).toFixed(2),
            todaySum: parseFloat(d.today_sum).toFixed(2),
            weekSum: parseFloat(d.week_sum).toFixed(2),
            lastPaymentSum: parseFloat(d.last_payment_sum).toFixed(2),
            lastPaymentDate: new Date(d.last_payment_date.split(' ')[0]),
            code: country.code.toLowerCase(),
            average: parseFloat(parseFloat(d.balance) / parseFloat(d.month_average)).toFixed(2)
          })
          if (d.balance > 0) {
            count++
          }
        })

        this.totalTodaySum = parseFloat(totalTodaySum).toFixed(2)
        this.totalWeekSum = parseFloat(totalWeekSum).toFixed(2)
        this.totalBalance = parseFloat(total).toFixed(2)
        this.totalDelayDebt = parseFloat(totalDelay).toFixed(2)
        this.totalLastPaymentSum = parseFloat(totalLastPaymentSum).toFixed(2)
        this.average = parseFloat(total / parseFloat(count)).toFixed(2)
        return orderBy(statistic, [(e) => {
          if (!sortingCb) {
            return parseFloat(e[this.sortingField])
          } else {
            return sortingCb(e[this.sortingField])
          }
        }], [this.sortingType])
      }
    },
    name: 'DebitTable'
  }
</script>

<style>
    .debit-table {
        margin-bottom: 0;
    }

    th.th-action {
        transition: all .4s;
    }

    th.th-action:hover {
        cursor: pointer;
        background-color: #fff !important;
    }

    .debit-table thead tr th {
        text-align: center;
    }

    .table-cell, .table-cell tr, .table-cell td {
        background-color: transparent !important;
        border: none;
    }
    .nobr {
        white-space:nowrap;
    }
</style>



// WEBPACK FOOTER //
// DebitTable.vue?77aaefc9